import React, { useState, useRef, useEffect, useCallback } from "react";
// import { ReactComponent as SearchIcon } from "../../Assets/Main/SearchBar/Search.svg";
import { ReactComponent as NotificationIcon } from "../../Assets/Main/SearchBar/notification.svg";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as DropdownIcon } from "../../Assets/Main/Utils/Dropdown.svg";
import { logout } from "../../Redux/Actions/authActions";
import { ReactComponent as Logout } from "../../Global Icons/logout.svg";
import NotificationPopup from "../Main/notificationPopup";
import ChangePasswordPopup from "../ChangePassword/ChangePasword";
import {
  fetchNotifications,
  markNotificationsRead,
} from "../../Redux/Actions/authActions";
import "./searchBar.css";

const SearchBar = () => {
  const { admin, isAuthenticated, payment_executive } = useSelector(
    (state) => state.admin
  );
  const unreadCount = useSelector(
    (state) => state.notification?.unreadCount ?? 0
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const loggedUser = isAuthenticated && admin?.data ? admin : payment_executive;

  const logoutFunction = (e) => {
    e.preventDefault();
    dispatch(logout());
    navigate("/");
  };

  const [isProfilePopupVisible, setIsProfilePopupVisible] = useState(false);
  const [isNotificationPopupVisible, setIsNotificationPopupVisible] =
    useState(false);
  const [notifications, setNotifications] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const isLoadingRef = useRef(false);
  const [isMarkingRead, setIsMarkingRead] = useState(false);
  const [isMarkingVisibleRead, setIsMarkingVisibleRead] = useState(false);

  const [prevUnreadCount, setPrevUnreadCount] = useState(0);
  const audioRef = useRef(null);

  const [isChangePasswordPopupOpen, setIsChangePasswordPopupOpen] = useState(false);

  useEffect(() => {
    if (
      loggedUser?.data?.role !== "admin" &&
      loggedUser?.data?.role !== "super_admin"
    )
      return;
    const intervalId = setInterval(async () => {
      try {
        const response = await dispatch(fetchNotifications(1, 10, -1, false));
        if (response) {
          const unreadCountFromApi = response.total || 0;

          if (unreadCountFromApi > prevUnreadCount) {
            if (audioRef.current) {
              audioRef.current
                .play()
                .catch((err) => console.error("Audio play error:", err));
            }
          }

          setPrevUnreadCount(unreadCountFromApi);
          dispatch({
            type: "UPDATE_UNREAD_COUNT",
            payload: unreadCountFromApi,
          });
        }
      } catch (error) {
        console.error("Error refreshing notifications:", error);
      }
    }, 300000);

    return () => clearInterval(intervalId);
  }, [dispatch, prevUnreadCount, loggedUser]);

  const loadNotifications = useCallback(async (pageNumber) => {
    if (isLoadingRef.current) return;
    isLoadingRef.current = true;
    try {
      const response = await dispatch(
        fetchNotifications(pageNumber, 10, -1, false)
      );
      if (response) {
        const newNotifications = response.data || [];
        if (newNotifications.length === 0) {
          setHasMore(false);
          isLoadingRef.current = false;
          return;
        }
        setNotifications((prev) =>
          pageNumber === 1 ? newNotifications : [...prev, ...newNotifications]
        );
        setPage(pageNumber);
        setHasMore(newNotifications.length >= 10);

        const unreadCountFromApi = response.total || 0;
        dispatch({ type: "UPDATE_UNREAD_COUNT", payload: unreadCountFromApi });
      }
    } catch (error) {
      console.error(error);
    }
    isLoadingRef.current = false;
  },
    [dispatch]
  )

  useEffect(() => {
    if (
      loggedUser?.data?.role === "admin" ||
      loggedUser?.data?.role === "super_admin"
    ) {
      loadNotifications(1);
    }
  }, [loadNotifications, loggedUser]);

  const loadMoreNotifications = () => {
    if (!hasMore) return;
    loadNotifications(page + 1);
  };

  const markAllAsRead = async () => {
    if (isMarkingRead) return;
    setIsMarkingRead(true);
    try {
      const unreadIds = notifications
        .filter((n) => !n.is_read)
        .map((n) => n._id);
      if (unreadIds.length > 0) {
        await dispatch(markNotificationsRead(unreadIds));
        setNotifications((prev) =>
          prev.map((notif) =>
            unreadIds.includes(notif._id) ? { ...notif, is_read: true } : notif
          )
        );
        dispatch({ type: "UPDATE_UNREAD_COUNT", payload: 0 });
      }
    } catch (error) {
      console.error(error);
    }
    setIsMarkingRead(false);
  };

  const markVisibleNotificationsRead = async (visibleIds) => {
    if (isMarkingVisibleRead) return;
    if (!visibleIds || visibleIds.length === 0) return;

    setIsMarkingVisibleRead(true);

    try {
      const toMarkIds = visibleIds.filter((id) =>
        notifications.find((n) => n._id === id && !n.is_read)
      );
      if (toMarkIds.length === 0) {
        setIsMarkingVisibleRead(false);
        return;
      }

      await dispatch(markNotificationsRead(toMarkIds));

      setNotifications((prev) =>
        prev.map((notif) =>
          toMarkIds.includes(notif._id) ? { ...notif, is_read: true } : notif
        )
      );
      const currentUnreadCount = unreadCount;
      const newUnreadCount = Math.max(0, currentUnreadCount - toMarkIds.length);
      dispatch({ type: "UPDATE_UNREAD_COUNT", payload: newUnreadCount });
    } catch (error) {
      console.error("Error marking visible notifications read:", error);
    }
    setIsMarkingVisibleRead(false);
  };

  const toggleProfilePopup = () => {
    setIsProfilePopupVisible(!isProfilePopupVisible);
    if (isNotificationPopupVisible) setIsNotificationPopupVisible(false);
  };

  const toggleNotificationPopup = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const willShow = !isNotificationPopupVisible;
    setIsNotificationPopupVisible(willShow);

    if (willShow) {
      await markAllAsRead();
    } else {
      await loadNotifications(1);
    }

    if (isProfilePopupVisible) setIsProfilePopupVisible(false);
  };

  const openChangePasswordPopup = () => {
    setIsChangePasswordPopupOpen(true);
    setIsProfilePopupVisible(false);
  };

  const closeChangePasswordPopup = () => {
    setIsChangePasswordPopupOpen(false);
  };

  const profilePopupRef = useRef(null);
  const notificationPopupRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        profilePopupRef.current &&
        !profilePopupRef.current.contains(event.target) &&
        notificationPopupRef.current &&
        !notificationPopupRef.current.contains(event.target)
      ) {
        setIsProfilePopupVisible(false);
        setIsNotificationPopupVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div>
      <div
        className="search-bar-container border-15 flex-container"
        style={{ background: "#F5F7FA" }}
      >
        <div style={{ background: "#F5F7FA", display: "flex", color: "#F5F7FA" }}>
          bbdshgg
        </div>

        {(loggedUser?.data?.role === "admin" ||
          loggedUser?.data?.role === "super_admin") && (
            <div
              style={{ position: "relative", marginLeft: "65%" }}
              className="search-bar-icon border-15"
            >
              <a
                href="/"
                onClick={toggleNotificationPopup}
                style={{ cursor: "pointer" }}
              >
                <NotificationIcon
                  style={{ marginTop: 4, background: "white", borderRadius: "50px" }}
                  className="icon"
                />
              </a>
              <span
                style={{
                  position: "absolute",
                  top: "-4px",
                  right: "10px",
                  backgroundColor: unreadCount === 0 ? "#000000" : "#e0245e",
                  color: unreadCount === 0 ? "#ffffff" : "white",
                  borderRadius: "100%",
                  padding: "2px 4px",
                  fontSize: "13px",
                  fontWeight: "700",
                  lineHeight: 1,
                  boxShadow: "0 0 4px rgba(0,0,0,0.3)",
                  minWidth: 22,
                  height: 22,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  userSelect: "none",
                  pointerEvents: "none",
                  zIndex: 10,
                }}
              >
                {unreadCount}
              </span>
            </div>
          )}

        <div className="search-bar-flex-spacer"></div>

        <div
          className="search-bar-profile"
          style={{ background: "white", width: "100%", borderRadius: "24px" }}
        >
          <div
            className="flex-container font-Medium flex-row flex-align-center flex-justify-between profile border-24"
            onClick={toggleProfilePopup}
            style={{ cursor: "pointer" }}
          >
            <div className="flex-container flex-align-center flex-row align-centre">
              <img
                src={
                  isAuthenticated && loggedUser?.data?.profile_image
                    ? loggedUser.data.profile_image
                    : require("../../Assets/Main/SearchBar/Profile.png")
                }
                alt="Profile"
              />
              <p style={{
                // fontFamily: "Gilroy-ExtraBold",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "53px" // Adjust width to suit your UI
              }}>
                {isAuthenticated && loggedUser?.data?.name
                  ? loggedUser.data.name
                  : "James"}
              </p>
            </div>
            <div>
              <DropdownIcon className="drop-icon" />
            </div>
          </div>
        </div>
      </div>

      {isNotificationPopupVisible && (
        <div ref={notificationPopupRef}>
          <NotificationPopup
            visible={isNotificationPopupVisible}
            notifications={notifications}
            loadMoreNotifications={loadMoreNotifications}
            markVisibleRead={markVisibleNotificationsRead}
          />
        </div>
      )}

      {isProfilePopupVisible && (
        <div className="popup" ref={profilePopupRef}>
          <div className="details_admin">
            <p style={{ fontFamily: "Gilroy-ExtraBold" }}>
              {isAuthenticated ? loggedUser.data.name : "No Data"}
            </p>
            <p style={{ color: "#c6c6c6" }}>
              {isAuthenticated ? loggedUser.data.email : "No Data"}
            </p>
          </div>
          <div className="profile_settings">
            <div className="dropdown_flex">
              {/* <img
                style={{ height: "20px", width: "30px" }}
                src="https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750930647433_image_profile.svg"
                alt=""
              />
              <p>Profile</p> */}
            </div>

            {(loggedUser?.data?.role === "admin" ||
              loggedUser?.data?.role === "super_admin") && (
                <Link to="/settings">
                  <div className="dropdown_flex">
                    <img
                      style={{ height: "20px", width: "30px" }}
                      src="https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750930878243_image_setting.svg"
                      alt=""
                    />
                    <p>Settings</p>
                  </div>
                </Link>
              )}

            {isAuthenticated && loggedUser?.data?.role === "super_admin" && (
              <Link to="/permissions">
                <div className="dropdown_flex">
                  <img
                    style={{ height: "20px", width: "30px" }}
                    src="https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750930963173_image_Permissions.svg"
                    alt=""
                  />
                  <p>Permissions</p>
                </div>
              </Link>
            )}

            {isAuthenticated && loggedUser?.data?.role === "super_admin" && (
              <button
                onClick={openChangePasswordPopup}
                className="dropdown_flex"
                style={{ border: "none", background: "none", cursor: "pointer", padding: 0 }}
              >
                <img
                  style={{ height: "20px", width: "30px" }}
                  src="https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1761887381746_image_PASSSWORD%20CHANGE.svg"
                  alt="Change Password"
                />
                <p style={{ fontWeight: "lighter", fontSize: "initial" }}>Change Password</p>
              </button>
            )}

          </div>
          <hr />
          <button onClick={logoutFunction} className="logout-button">
            <Logout style={{ width: "33px", height: "15px" }} />
            Logout
          </button>
        </div>
      )}

      {/* Remove old modal and render ChangePasswordPopup directly inline */}
      {isChangePasswordPopupOpen && (
        <ChangePasswordPopup onClose={closeChangePasswordPopup} />
      )}

      <audio ref={audioRef} src="../../Assets/notification/notification.mp3" preload="auto" />
    </div>
  );
};

export default SearchBar;
